import { auth } from "./firebase";
import type { VanityLink, VanityLinkWrite, ClickStats, WhitelistEntry } from "../../api/_lib/types";

async function authFetch(path: string, init?: RequestInit): Promise<Response> {
  const token = await auth.currentUser?.getIdToken();
  return fetch(path, {
    ...init,
    headers: {
      "Content-Type": "application/json",
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...init?.headers,
    },
  });
}

async function json<T>(path: string, init?: RequestInit): Promise<T> {
  const res = await authFetch(path, init);
  if (!res.ok) {
    const err = await res.json().catch(() => ({ error: res.statusText }));
    throw new Error(err.error ?? "Request failed");
  }
  return res.json() as Promise<T>;
}

// Links
export const api = {
  links: {
    list: () => json<VanityLink[]>("/api/links"),
    get: (slug: string) => json<VanityLink>(`/api/links/${slug}`),
    create: (data: VanityLinkWrite) =>
      json<{ slug: string }>("/api/links", { method: "POST", body: JSON.stringify(data) }),
    update: (slug: string, data: Partial<Omit<VanityLinkWrite, "slug">>) =>
      json<{ ok: boolean }>(`/api/links/${slug}`, { method: "PUT", body: JSON.stringify(data) }),
    delete: (slug: string) =>
      json<{ ok: boolean }>(`/api/links/${slug}`, { method: "DELETE" }),
  },
  stats: {
    get: (slug: string) => json<ClickStats>(`/api/stats/${slug}`),
  },
  whitelist: {
    list: () => json<WhitelistEntry[]>("/api/whitelist"),
    add: (email: string) =>
      json<{ ok: boolean }>("/api/whitelist", { method: "POST", body: JSON.stringify({ email }) }),
    remove: (email: string) =>
      json<{ ok: boolean }>(`/api/whitelist/${encodeURIComponent(email)}`, { method: "DELETE" }),
  },
};
